function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "20F99732-AADF-4441-B0A0-3B22BB571AA2");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "75.5932687%",
  y1: "90.0714565%",
  x2: "40.973369%",
  y2: "35.8672351%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F89F21",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F79A23",
  offset: "25.02%"
}), React.createElement("stop", {
  stopColor: "#F78E22",
  offset: "53.31%"
}), React.createElement("stop", {
  stopColor: "#F68721",
  offset: "61.96%"
}), React.createElement("stop", {
  stopColor: "#F48220",
  offset: "72.32%"
}), React.createElement("stop", {
  stopColor: "#F27623",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "70.1244483%",
  y1: "89.3345243%",
  x2: "19.5268262%",
  y2: "-9.56150359%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#F68721",
  stopOpacity: 0,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E27027",
  stopOpacity: 0.2704,
  offset: "35.87%"
}), React.createElement("stop", {
  stopColor: "#D4612C",
  stopOpacity: 0.5299,
  offset: "70.3%"
}), React.createElement("stop", {
  stopColor: "#D15D2D",
  stopOpacity: 0.74,
  offset: "98.16%"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "In-App-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Checkout---Flat-69-Plan-(Single)-+-Paypal",
  transform: "translate(-302.000000, -474.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(128.000000, 390.000000)"
}, React.createElement("g", {
  id: "Group-11",
  transform: "translate(0.000000, 84.000000)"
}, React.createElement("g", {
  id: "download-(4)",
  transform: "translate(174.000000, 0.000000)"
}, React.createElement("path", {
  d: "M47.3525294,29.502439 L2.05923529,29.502439 C0.926470588,29.502439 0,28.6173659 0,27.5356098 L0,1.96682927 C0,0.885073171 0.926470588,0 2.05923529,0 L47.3525294,0 C48.4852941,0 49.4117647,0.885073171 49.4117647,1.96682927 L49.4117647,27.5356098 C49.4117647,28.6173659 48.4852941,29.502439 47.3525294,29.502439 Z",
  id: "Shape",
  fill: "#113152"
}), React.createElement("path", {
  d: "M6.79164706,16.4095024 C6.37411765,16.7844293 5.83305882,16.947922 4.97576471,16.947922 L4.61752941,16.947922 L4.61752941,12.4660098 L4.97576471,12.4660098 C5.83305882,12.4660098 6.35311765,12.618439 6.79164706,13.0142634 C7.24870588,13.419922 7.52664706,14.0517659 7.52664706,14.7008195 C7.52664706,15.3523317 7.24994118,16.0038439 6.79164706,16.4095024 Z M5.24135294,11.3166439 L3.29329412,11.3166439 L3.29329412,18.0960585 L5.23270588,18.0960585 C6.26170588,18.0960585 7.00535294,17.8538927 7.65758824,17.3130146 C8.43582353,16.6737951 8.89288235,15.7088195 8.89288235,14.7118829 C8.89288235,12.7106341 7.39323529,11.3166439 5.24135294,11.3166439 Z M9.50682353,18.0960585 L10.8335294,18.0960585 L10.8335294,11.3178732 L9.50682353,11.3178732 L9.50682353,18.0960585 Z M14.0737059,13.9190049 C13.2769412,13.6239805 13.0434706,13.4309854 13.0434706,13.0646634 C13.0434706,12.6381073 13.461,12.3148098 14.0317059,12.3148098 C14.4294706,12.3148098 14.7568235,12.4770732 15.1027059,12.8630634 L15.7969412,11.9570927 C15.2262353,11.459239 14.5431176,11.2047805 13.7982353,11.2047805 C12.5938235,11.2047805 11.676,12.0382244 11.676,13.1470244 C11.676,14.0812683 12.1034118,14.5606829 13.3498235,15.0069073 C13.8686471,15.188839 14.1342353,15.3105366 14.2676471,15.3928976 C14.5332353,15.5649951 14.6654118,15.8108488 14.6654118,16.0935805 C14.6654118,16.6442927 14.2281176,17.0524098 13.6351765,17.0524098 C13.0051765,17.0524098 12.4937647,16.7352585 12.1898824,16.1476683 L11.3313529,16.971278 C11.9428235,17.8637268 12.6778235,18.2620098 13.6870588,18.2620098 C15.0656471,18.2620098 16.0341176,17.3462049 16.0341176,16.0345756 C16.0341176,14.9577366 15.5857059,14.4697171 14.0761765,13.9202341 L14.0737059,13.9190049 Z M16.4491765,14.7118829 C16.4491765,16.7032976 18.018,18.2484878 20.0401765,18.2484878 C20.6108824,18.2484878 21.1000588,18.1378537 21.7041176,17.855122 L21.7041176,16.297639 C21.1729412,16.8262244 20.7035294,17.0401171 20.1019412,17.0401171 C18.7653529,17.0401171 17.8166471,16.0751415 17.8166471,14.7045073 C17.8166471,13.4014829 18.795,12.3750439 20.0401765,12.3750439 C20.6726471,12.3750439 21.1519412,12.6 21.7041176,13.1371902 L21.7041176,11.5809366 C21.1210588,11.2859122 20.6417647,11.1629854 20.0710588,11.1629854 C18.0612353,11.1629854 16.4491765,12.7401366 16.4491765,14.7118829 Z M32.2263529,15.8710829 L30.4129412,11.3166439 L28.9627059,11.3166439 L31.8495882,18.2693854 L32.5635882,18.2693854 L35.5035882,11.3178732 L34.0644706,11.3178732 L32.2263529,15.8710829 Z M36.1027059,18.0960585 L39.8654118,18.0960585 L39.8654118,16.947922 L37.4281765,16.947922 L37.4281765,15.1187707 L39.7752353,15.1187707 L39.7752353,13.9706341 L37.4281765,13.9706341 L37.4281765,12.4660098 L39.8654118,12.4660098 L39.8654118,11.3166439 L36.1027059,11.3166439 L36.1027059,18.0960585 Z M42.4607647,14.4377561 L42.0728824,14.4377561 L42.0728824,12.384878 L42.4805294,12.384878 C43.3081765,12.384878 43.7578235,12.7290732 43.7578235,13.3904195 C43.7578235,14.0714341 43.3081765,14.4377561 42.4607647,14.4377561 Z M45.1228235,13.319122 C45.1228235,12.0492878 44.2457647,11.3178732 42.714,11.3178732 L40.7474118,11.3178732 L40.7474118,18.0960585 L42.0728824,18.0960585 L42.0728824,15.3732293 L42.2458235,15.3732293 L44.0827059,18.0960585 L45.7132941,18.0960585 L43.5725294,15.2404683 C44.5731176,15.037639 45.1228235,14.3553951 45.1228235,13.319122 Z",
  id: "Shape",
  fill: "#FFFFFF"
}), React.createElement("g", {
  id: "MarkingBase_1_",
  transform: "translate(22.004689, 11.120812)"
}, React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-1)",
  cx: 3.69773085,
  cy: 3.73741079,
  rx: 3.69373846,
  ry: 3.67572023
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  opacity: 0.65,
  cx: 3.69773085,
  cy: 3.73741079,
  rx: 3.69373846,
  ry: 3.67572023
})), React.createElement("g", {
  id: "Orange_1_",
  transform: "translate(24.563820, 18.002857)",
  fill: "#FF8126"
}, React.createElement("g", {
  id: "Orange"
}, React.createElement("path", {
  d: "M0,11.5360437 C11.6505559,11.5360437 23.1851859,11.5360437 23.1851859,11.5360437 C24.1705563,11.5360437 24.9240748,10.7862009 24.9240748,9.80563715 L24.9240748,0 C24.9240748,0 22.1418525,7.95987016 0,11.5360437 Z",
  id: "Shape"
}))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "50px",
    height: "30px",
    viewBox: "0 0 50 30",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/icon-discover.18ae8efb.svg";
export { SvgComponent as ReactComponent };